var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 499.768,
    height: 474.037,
    viewBox: "0 0 499.768 474.037",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Tracciato_21",
    x: 72.092,
    y: 45.697,
    width: 335.911,
    height: 369.651,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0220ab"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Tracciato_22",
    x: 195.771,
    y: 78.923,
    width: 282.323,
    height: 372.777,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0220ab"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -374.521,
    y1: -506.948,
    x2: -14.194,
    y2: -19.398,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#045b8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#07628d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.533,
    stopColor: "#178296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#20969c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#249e9e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1133.123,
    y1: -1400.407,
    x2: -19.657,
    y2: -24.434,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "Tracciato_37",
    x: 137.877,
    y: 368.284,
    width: 239.042,
    height: 68.408,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0220ab"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -60.315,
    y1: -85.303,
    x2: -2.396,
    y2: -3.589,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4.863,
    y1: -4.274,
    x2: 0.91,
    y2: 0.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.744,
    y1: -2.841,
    x2: 0.337,
    y2: -0.169,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -1.874,
    y1: -0.406,
    x2: 0.395,
    y2: 0.431,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.065,
    y1: 0.197,
    x2: 0.734,
    y2: 0.636,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -45.589,
    y1: -58.647,
    x2: -0.799,
    y2: -1.169,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_24",
    "data-name": "Raggruppa 24",
    transform: "translate(-1469 -5133)",
    opacity: 0.059
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23",
    "data-name": "Raggruppa 23",
    transform: "translate(1469 5133)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_75",
    "data-name": "Rettangolo 75",
    width: 67.758,
    height: 67.759,
    transform: "translate(431.968 406.278)",
    fill: "#83949e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_22",
    "data-name": "Raggruppa 22",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_10",
    "data-name": "Tracciato 10",
    d: "M467,459.289c-.284-.1-.557-.2-.842-.3C466.44,459.092,466.714,459.191,467,459.289Z",
    transform: "translate(-256.296 -18.061)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    "data-name": "Tracciato 11",
    d: "M468.708,459.715c-.448-.11-.885-.241-1.322-.35C467.823,459.474,468.261,459.605,468.708,459.715Z",
    transform: "translate(-244.083 -14.377)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_12",
    "data-name": "Tracciato 12",
    d: "M683.1,424.134A197.737,197.737,0,0,0,645.9,420.6c-108.618,0-197,88.377-197,197a196.338,196.338,0,0,0,56.681,138.128A223.177,223.177,0,0,1,477.97,647.951C477.97,530.665,568.325,434.08,683.1,424.134Z",
    transform: "translate(-427.562 -399.258)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    "data-name": "Tracciato 13",
    d: "M468.388,459.675c-.536-.164-1.071-.317-1.607-.481C467.316,459.358,467.852,459.511,468.388,459.675Z",
    transform: "translate(-250.09 -16.075)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_14",
    "data-name": "Tracciato 14",
    d: "M471.446,459.972l-.7-.044Z",
    transform: "translate(-210.719 -8.786)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_15",
    "data-name": "Tracciato 15",
    d: "M471.6,460.032c-.536-.054-1.071-.12-1.6-.175C470.526,459.912,471.061,459.977,471.6,460.032Z",
    transform: "translate(-218.117 -9.491)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16",
    "data-name": "Tracciato 16",
    d: "M469.586,459.859c-.514-.109-1.016-.208-1.519-.328C468.57,459.651,469.072,459.75,469.586,459.859Z",
    transform: "translate(-237.321 -12.728)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_17",
    "data-name": "Tracciato 17",
    d: "M473.009,460.027l-1.65-.066Z",
    transform: "translate(-204.632 -8.448)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_18",
    "data-name": "Tracciato 18",
    d: "M470.192,459.94c-.5-.087-1.017-.185-1.519-.284C469.176,459.754,469.689,459.853,470.192,459.94Z",
    transform: "translate(-231.303 -11.487)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_19",
    "data-name": "Tracciato 19",
    d: "M470.6,459.942l-1.214-.164Z",
    transform: "translate(-224.174 -10.276)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_20",
    "data-name": "Tracciato 20",
    d: "M467.026,459.329c-.5-.186-.995-.371-1.486-.557C466.032,458.958,466.523,459.144,467.026,459.329Z",
    transform: "translate(-262.413 -20.265)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Tracciato_21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_21-2",
    "data-name": "Tracciato 21",
    d: "M453.551,625.828A202.515,202.515,0,0,0,519.336,775.29a197.04,197.04,0,0,0,140.183,7.935c-1.2.032-2.393.066-3.6.066a157.545,157.545,0,1,1,133.265-241.6l.273.448A197.762,197.762,0,0,0,704.222,428.5a202.88,202.88,0,0,0-47.675-5.673C544.617,422.832,453.551,513.9,453.551,625.828Z",
    transform: "translate(-381.46 -377.13)",
    fill: "#8a1e41"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Tracciato_22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_22-2",
    "data-name": "Tracciato 22",
    d: "M747.19,595.642a202.975,202.975,0,0,0-91.841-169.77A218.111,218.111,0,0,1,699.7,616.539c-.044.339-.076.678-.131,1.027a157.183,157.183,0,0,1-50.987,95.415c-.852.765-1.705,1.52-2.568,2.252a217.747,217.747,0,0,1-158.578,68.408,219.99,219.99,0,0,1-22.57-1.158c2.426,1.027,4.874,2.033,7.356,2.973.492.186.983.372,1.486.557q2.606.967,5.246,1.869c.284.1.558.2.842.3,1.978.667,3.978,1.29,5.99,1.891.535.164,1.071.317,1.607.481,1.661.481,3.322.94,5.005,1.388.437.11.875.241,1.322.35,2.022.525,4.066,1.006,6.121,1.465.5.12,1.005.219,1.519.328,1.694.372,3.4.71,5.1,1.039.5.1,1.016.2,1.519.284q3.148.574,6.328,1.049l1.214.164c1.814.251,3.628.492,5.454.7.525.055,1.06.12,1.6.175,2.175.23,4.35.437,6.547.6l.7.043c1.989.142,3.989.241,6,.328l1.65.066c2.229.066,4.47.12,6.711.12C656.124,798.648,747.19,707.583,747.19,595.642Z",
    transform: "translate(-269.1 -346.95)",
    fill: "#8a1e41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_23",
    "data-name": "Tracciato 23",
    d: "M681.227,596.009c0,111.941-91.065,203.007-203.007,203.007-2.24,0-4.481-.055-6.711-.12,2.23.066,4.459.12,6.711.12,111.974,0,203.083-91.109,203.083-203.094a203.05,203.05,0,0,0-92.268-170.087l.35.4A202.975,202.975,0,0,1,681.227,596.009Z",
    transform: "translate(-203.133 -347.317)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_24",
    "data-name": "Tracciato 24",
    d: "M471.933,460.626c-1.683-.448-3.344-.907-5.005-1.388C468.589,459.719,470.25,460.178,471.933,460.626Z",
    transform: "translate(-248.63 -15.638)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_25",
    "data-name": "Tracciato 25",
    d: "M476.694,460.474c-2.2-.164-4.372-.372-6.547-.6C472.322,460.1,474.5,460.31,476.694,460.474Z",
    transform: "translate(-216.667 -9.332)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_26",
    "data-name": "Tracciato 26",
    d: "M475.14,460.731q-3.18-.476-6.328-1.049Q471.96,460.256,475.14,460.731Z",
    transform: "translate(-229.923 -11.229)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_27",
    "data-name": "Tracciato 27",
    d: "M474.956,460.492c-1.825-.208-3.64-.448-5.454-.7C471.316,460.044,473.131,460.285,474.956,460.492Z",
    transform: "translate(-223.072 -10.127)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_28",
    "data-name": "Tracciato 28",
    d: "M473.31,460.6c-1.705-.328-3.41-.667-5.1-1.039C469.9,459.933,471.605,460.271,473.31,460.6Z",
    transform: "translate(-235.941 -12.43)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_29",
    "data-name": "Tracciato 29",
    d: "M473.628,460.862c-2.055-.459-4.1-.94-6.121-1.464C469.529,459.922,471.573,460.4,473.628,460.862Z",
    transform: "translate(-242.881 -14.059)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_30",
    "data-name": "Tracciato 30",
    d: "M472.223,460.912c-2.011-.6-4.011-1.224-5.99-1.891C468.212,459.688,470.211,460.311,472.223,460.912Z",
    transform: "translate(-255.532 -17.792)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_31",
    "data-name": "Tracciato 31",
    d: "M476.81,460.26c-2.011-.087-4.011-.186-6-.328C472.8,460.074,474.8,460.173,476.81,460.26Z",
    transform: "translate(-210.084 -8.746)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32",
    "data-name": "Tracciato 32",
    d: "M453.64,625.987c0-111.93,91.065-203,203-203a202.874,202.874,0,0,1,47.675,5.673l-.481-.3c-.437-.11-.885-.229-1.333-.328a202.735,202.735,0,0,0-45.861-5.224c-111.985,0-203.094,91.1-203.094,203.083a202.617,202.617,0,0,0,65.807,149.517l.077.032A202.514,202.514,0,0,1,453.64,625.987Z",
    transform: "translate(-381.549 -377.294)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33",
    "data-name": "Tracciato 33",
    d: "M464.863,458.5c.5.219,1.016.449,1.519.656,1.945.809,3.9,1.574,5.88,2.328-2.481-.94-4.929-1.945-7.356-2.973Z",
    transform: "translate(-269.135 -22.976)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_34",
    "data-name": "Tracciato 34",
    d: "M470.922,460.692q-2.639-.9-5.246-1.869Q468.282,459.79,470.922,460.692Z",
    transform: "translate(-261.062 -19.758)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_35",
    "data-name": "Tracciato 35",
    d: "M465.119,458.623l-.743-.339Z",
    transform: "translate(-273.971 -25.111)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_36",
    "data-name": "Tracciato 36",
    d: "M464.048,458.13l-.241-.12Z",
    transform: "translate(-279.621 -27.831)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Tracciato_37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37-2",
    "data-name": "Tracciato 37",
    d: "M540.034,520.755a217.747,217.747,0,0,0,158.578-68.408,156.837,156.837,0,0,1-97.2,37.773c-.557.021-1.115.021-1.661.033a197.04,197.04,0,0,1-140.183-7.935c.339.306.656.612.995.918l.076.044a204.136,204.136,0,0,0,16.537,13.487l.7.514q1.328.967,2.656,1.9c.481.339.962.667,1.454,1.005.688.47,1.377.951,2.077,1.41.831.568,1.672,1.115,2.513,1.661.372.24.744.491,1.126.732a203.429,203.429,0,0,0,18.176,10.35l.241.12c1.978.995,3.967,1.945,5.978,2.874l.743.339c1.53.688,3.071,1.355,4.623,2.022A220.029,220.029,0,0,0,540.034,520.755Z",
    transform: "translate(-321.69 -84.06)",
    fill: "#8a1e41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_38",
    "data-name": "Tracciato 38",
    d: "M731.256,426.894a219.734,219.734,0,0,1,55.806,47.675A203.05,203.05,0,0,1,879.33,644.656c0,111.985-91.109,203.094-203.083,203.094-2.251,0-4.481-.055-6.711-.12l-1.65-.066c-2.011-.087-4.011-.186-6-.328l-.7-.044c-2.2-.164-4.372-.372-6.547-.6-.536-.054-1.071-.12-1.6-.175-1.825-.207-3.64-.448-5.453-.7l-1.214-.164q-3.18-.476-6.328-1.049c-.5-.087-1.017-.186-1.519-.284-1.705-.328-3.41-.667-5.1-1.039-.514-.109-1.016-.208-1.519-.328-2.055-.459-4.1-.94-6.121-1.464-.448-.109-.885-.241-1.323-.35-1.683-.448-3.344-.907-5.005-1.388-.536-.164-1.071-.317-1.607-.481-2.011-.6-4.011-1.224-5.99-1.891-.284-.1-.557-.2-.842-.3q-2.639-.9-5.246-1.869c-.5-.185-.995-.371-1.486-.557-1.978-.754-3.935-1.519-5.88-2.328-.5-.208-1.017-.437-1.519-.656-1.541-.656-3.06-1.322-4.58-2.011l-.743-.339q-3.017-1.394-5.978-2.874l-.241-.12A203.786,203.786,0,0,1,540,795.135c-.35-.317-.688-.645-1.039-.962a202.617,202.617,0,0,1-65.807-149.517c0-111.985,91.109-203.083,203.094-203.083a202.735,202.735,0,0,1,45.861,5.224c.448.1.9.219,1.333.328a195.6,195.6,0,0,0-66.747-26.2c-114.772,9.946-205.127,106.531-205.127,223.817A223.179,223.179,0,0,0,479.186,752.52c.208.372.393.754.6,1.126l-.033-.033c.24.437.492.853.732,1.29.47.819.94,1.65,1.41,2.47.306.513.612,1.017.907,1.53.59.995,1.18,1.979,1.782,2.951l.207.35q4.886,7.918,10.383,15.4l.185.24c.853,1.158,1.716,2.306,2.591,3.454l.393.514c.853,1.093,1.705,2.186,2.58,3.268l.481.6c.863,1.06,1.727,2.12,2.6,3.17l.514.6c.886,1.049,1.782,2.1,2.689,3.137l.383.426q3.951,4.492,8.142,8.776c.481.481.951.984,1.443,1.465s.973.973,1.465,1.454c.776.765,1.541,1.519,2.328,2.274l1.115,1.049c.951.9,1.9,1.793,2.875,2.678l.7.634.4.361c.459.426.918.853,1.388,1.268l.12.066a223.7,223.7,0,0,0,148.675,56.4c123.9,0,224.68-100.793,224.68-224.691C900.927,539.83,828.639,451.486,731.256,426.894Z",
    transform: "translate(-401.16 -396.051)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_39",
    "data-name": "Tracciato 39",
    d: "M470.335,421.7a195.6,195.6,0,0,1,66.747,26.2,201.917,201.917,0,0,1,62.627,26.777c.339.219.667.448.995.667A219.735,219.735,0,0,0,544.9,427.669a224.342,224.342,0,0,0-55.009-6.82Q480,420.849,470.335,421.7Z",
    transform: "translate(-214.8 -396.826)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_40",
    "data-name": "Tracciato 40",
    d: "M464.444,458.315c1.519.688,3.038,1.355,4.58,2.011l.044.011C467.515,459.67,465.974,459,464.444,458.315Z",
    transform: "translate(-273.296 -24.803)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_41",
    "data-name": "Tracciato 41",
    d: "M464.444,458.315c1.519.688,3.038,1.355,4.58,2.011l.044.011C467.515,459.67,465.974,459,464.444,458.315Z",
    transform: "translate(-273.296 -24.803)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_42",
    "data-name": "Tracciato 42",
    d: "M486.647,476.051c-.842-.547-1.683-1.093-2.514-1.661-.7-.459-1.388-.94-2.076-1.41-.492-.339-.973-.666-1.454-1.005q-1.328-.934-2.656-1.9l-.7-.514a204.081,204.081,0,0,1-16.537-13.487l-.076-.044c-.339-.306-.656-.612-.995-.918l-.077-.032c.35.317.689.644,1.039.962a203.783,203.783,0,0,0,45.347,31.095,203.389,203.389,0,0,1-18.176-10.35C487.39,476.542,487.019,476.291,486.647,476.051Z",
    transform: "translate(-321.762 -56.955)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_43",
    "data-name": "Tracciato 43",
    d: "M486.647,476.051c-.842-.547-1.683-1.093-2.514-1.661-.7-.459-1.388-.94-2.076-1.41-.492-.339-.973-.666-1.454-1.005q-1.328-.934-2.656-1.9l-.7-.514a204.081,204.081,0,0,1-16.537-13.487l-.076-.044c-.339-.306-.656-.612-.995-.918l-.077-.032c.35.317.689.644,1.039.962a203.783,203.783,0,0,0,45.347,31.095,203.389,203.389,0,0,1-18.176-10.35C487.39,476.542,487.019,476.291,486.647,476.051Z",
    transform: "translate(-321.762 -56.955)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_44",
    "data-name": "Tracciato 44",
    d: "M476.442,423.324l.481.3a201.95,201.95,0,0,1,63.49,27.553l-.35-.4c-.328-.218-.656-.448-.995-.667A201.915,201.915,0,0,0,476.442,423.324Z",
    transform: "translate(-154.16 -372.25)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_21",
    "data-name": "Raggruppa 21"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_20",
    "data-name": "Raggruppa 20",
    transform: "translate(137.877 51.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_45",
    "data-name": "Tracciato 45",
    d: "M599.753,490.153a197.04,197.04,0,0,1-140.183-7.935c.339.306.656.612.995.918l.076.044a204.136,204.136,0,0,0,16.537,13.487l.7.514q1.328.967,2.656,1.9c.481.339.962.667,1.454,1.005.688.47,1.377.951,2.077,1.41.831.568,1.672,1.115,2.513,1.661.372.24.744.491,1.126.732a203.429,203.429,0,0,0,18.176,10.35l.241.12c1.978.995,3.967,1.945,5.978,2.874l.743.339c1.53.688,3.071,1.355,4.623,2.022a220.029,220.029,0,0,0,22.57,1.158,217.747,217.747,0,0,0,158.578-68.408,156.837,156.837,0,0,1-97.2,37.773C600.857,490.142,600.3,490.142,599.753,490.153Z",
    transform: "translate(-459.57 -135.432)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_46",
    "data-name": "Tracciato 46",
    d: "M590.417,590.323A217.376,217.376,0,0,0,539.976,450.9a201.949,201.949,0,0,0-63.49-27.553,197.762,197.762,0,0,1,85.24,113.635,157.42,157.42,0,0,1,22.6,104.586A218.264,218.264,0,0,0,590.417,590.323Z",
    transform: "translate(-291.601 -423.351)",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_47",
    "data-name": "Tracciato 47",
    d: "M832.858,497.169a219.733,219.733,0,0,0-55.806-47.675A216.955,216.955,0,0,0,665.3,418.651c-120.39,0-218.341,97.951-218.341,218.341,0,86.989,51.129,162.239,124.9,197.313l-.4-.361-.7-.634c-.973-.885-1.924-1.781-2.875-2.678l-1.115-1.049c-.787-.754-1.552-1.508-2.328-2.274-.492-.481-.984-.961-1.465-1.454s-.962-.983-1.443-1.465q-4.18-4.278-8.142-8.776l-.383-.426c-.907-1.038-1.8-2.088-2.689-3.137l-.514-.6c-.874-1.049-1.738-2.109-2.6-3.17l-.481-.6c-.875-1.082-1.727-2.175-2.58-3.268l-.393-.514c-.875-1.147-1.738-2.3-2.591-3.454l-.185-.24q-5.492-7.476-10.383-15.4l-.207-.35c-.6-.972-1.191-1.956-1.782-2.951-.3-.513-.6-1.017-.907-1.53-.47-.82-.94-1.651-1.41-2.47-.241-.437-.492-.853-.732-1.29l.032.033c-.207-.371-.393-.754-.6-1.126A196.339,196.339,0,0,1,468.3,636.992c0-108.618,88.377-197,197-197a197.736,197.736,0,0,1,37.193,3.531,195.6,195.6,0,0,1,66.747,26.2l.481.3a201.949,201.949,0,0,1,63.49,27.553Z",
    transform: "translate(-446.955 -418.651)",
    fill: "url(#linear-gradient-7)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_48",
    "data-name": "Tracciato 48",
    d: "M469.807,460.9c-2.011-.929-4-1.88-5.979-2.874Q466.8,459.5,469.807,460.9Z",
    transform: "translate(-279.402 -27.722)",
    fill: "#ff5c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_49",
    "data-name": "Tracciato 49",
    d: "M469.807,460.9c-2.011-.929-4-1.88-5.979-2.874Q466.8,459.5,469.807,460.9Z",
    transform: "translate(-279.402 -27.722)",
    fill: "url(#linear-gradient-8)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircles);
export default __webpack_public_path__ + "static/media/circles.8dc9956da1fa7008b93db2394c109767.svg";
export { ForwardRef as ReactComponent };